import { usePermissionsContext } from "./PermissionContext";

export const usePermissions = () => {
  const { privileges, can, canAny } = usePermissionsContext();
  return { privileges, can, canAny };
};
